import { render, staticRenderFns } from "./offerwall-noti.vue?vue&type=template&id=18cd675c&"
import script from "./offerwall-noti.vue?vue&type=script&lang=js&"
export * from "./offerwall-noti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports